function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.875 3.75H3.125C1.79688 3.75 0.664062 4.84375 0.664062 6.21094V18.8672C0.664062 20.1953 1.75781 21.3281 3.125 21.3281H21.875C23.2031 21.3281 24.3359 20.2344 24.3359 18.8672V6.17188C24.3359 4.84375 23.2031 3.75 21.875 3.75ZM21.875 5.50781C21.9141 5.50781 21.9531 5.50781 21.9922 5.50781L12.5 11.6016L3.00781 5.50781C3.04687 5.50781 3.08594 5.50781 3.125 5.50781H21.875ZM21.875 19.4922H3.125C2.73438 19.4922 2.42187 19.1797 2.42187 18.7891V7.22656L11.5625 13.0859C11.8359 13.2812 12.1484 13.3594 12.4609 13.3594C12.7734 13.3594 13.0859 13.2812 13.3594 13.0859L22.5 7.22656V18.8281C22.5781 19.2187 22.2656 19.4922 21.875 19.4922Z",
    fill: "#3674CB",
    style: {
      fill: "#3674CB",
      fill: "color(display-p3 0.2118 0.4549 0.7961)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.e1ec1e1cd3281465a14f7faa8b912230.svg";
export { ForwardRef as ReactComponent };